'use strict';

module.exports = function () {
    $('.js-locale-toggler').on('click', function (e) {
        e.preventDefault();
        var $this = $(this);
        var queryString = $('.page').data('querystring');
        var action = $('.page').data('action');
        var url = $this.attr('href');
        var localeCode = $this.data('locale');
        var localeCurrencyCode = $this.data('currencycode');

        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            data: {
                code: localeCode,
                queryString: queryString,
                CurrencyCode: localeCurrencyCode,
                action: action
            },
            success: function (response) {
                $.spinner().stop();
                if (response && response.redirectUrl) {
                    window.location.href = response.redirectUrl;
                }
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });
};
